import { TranslateService } from '@ngx-translate/core';
import { Subject, of } from 'rxjs';
import { AuthService } from './auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "./auth.service";
var AppTranslationService = /** @class */ (function () {
    function AppTranslationService(translate, _authService) {
        this.translate = translate;
        this._authService = _authService;
        this.onLanguageChanged = new Subject();
        this.languageChanged$ = this.onLanguageChanged.asObservable();
        this.addLanguages(['en', 'hi', 'ba', 'ur']);
        this.setDefaultLanguage(this._authService.CurrentLanguage);
    }
    AppTranslationService.prototype.addLanguages = function (lang) {
        this.translate.addLangs(lang);
    };
    AppTranslationService.prototype.setDefaultLanguage = function (lang) {
        this.translate.setDefaultLang(lang);
    };
    AppTranslationService.prototype.getDefaultLanguage = function () {
        return this.translate.defaultLang;
    };
    AppTranslationService.prototype.getBrowserLanguage = function () {
        return this.translate.getBrowserLang();
    };
    AppTranslationService.prototype.getCurrentLanguage = function () {
        return this.translate.currentLang;
    };
    AppTranslationService.prototype.getLoadedLanguages = function () {
        return this.translate.langs;
    };
    AppTranslationService.prototype.useBrowserLanguage = function () {
        var browserLang = this.getBrowserLanguage();
        if (browserLang.match(/en|fr|de|pt|ar|ko/)) {
            this.changeLanguage(browserLang);
            return browserLang;
        }
    };
    AppTranslationService.prototype.useDefaultLangage = function () {
        return this.changeLanguage(null);
    };
    AppTranslationService.prototype.changeLanguage = function (language) {
        var _this = this;
        if (!language) {
            language = this.getDefaultLanguage();
        }
        if (language != this.translate.currentLang) {
            setTimeout(function () {
                _this.translate.use(language);
                _this.onLanguageChanged.next(language);
            });
        }
        return language;
    };
    AppTranslationService.prototype.getTranslation = function (key, interpolateParams) {
        return this.translate.instant(key, interpolateParams);
    };
    AppTranslationService.prototype.getTranslationAsync = function (key, interpolateParams) {
        return this.translate.get(key, interpolateParams);
    };
    AppTranslationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppTranslationService_Factory() { return new AppTranslationService(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.AuthService)); }, token: AppTranslationService, providedIn: "root" });
    return AppTranslationService;
}());
export { AppTranslationService };
var TranslateLanguageLoader = /** @class */ (function () {
    function TranslateLanguageLoader() {
    }
    TranslateLanguageLoader.prototype.getTranslation = function (lang) {
        // Note Dynamic require(variable) will not work. Require is always at compile time
        switch (lang) {
            case 'en':
                return of(require('../../assets/locale/en.json'));
            case 'hi':
                return of(require('../../assets/locale/hin.json'));
            case 'ba':
                return of(require('../../assets/locale/ban.json'));
            case 'ur':
                return of(require('../../assets/locale/ur.json'));
            default:
                return of(require('../../assets/locale/en.json'));
        }
    };
    return TranslateLanguageLoader;
}());
export { TranslateLanguageLoader };
